import React from 'react';
import Script from 'next/script';
import GTMLoader from '@/components/app/scripts/gtmLoader/GtmLoader';
import Yektanet from '@/components/app/scripts/yektanet/Yektanet';
import GoftinoLoader from '@/components/app/scripts/goftinoLoader/GoftinoLoader';
import OfflineTryAgain from '@/components/app/scripts/offlineTryAgain/OfflineTryAgain';
import IntrackLoader from './intrackLoader/IntrackLoader';
const Scripts = () => {
  return <>
      <Script strategy="beforeInteractive" src="/runtime-config.js" data-sentry-element="Script" data-sentry-source-file="Scripts.tsx" />
      <GTMLoader data-sentry-element="GTMLoader" data-sentry-source-file="Scripts.tsx" />
      <GoftinoLoader data-sentry-element="GoftinoLoader" data-sentry-source-file="Scripts.tsx" />
      <Yektanet data-sentry-element="Yektanet" data-sentry-source-file="Scripts.tsx" />
      <OfflineTryAgain data-sentry-element="OfflineTryAgain" data-sentry-source-file="Scripts.tsx" />
      <IntrackLoader data-sentry-element="IntrackLoader" data-sentry-source-file="Scripts.tsx" />
    </>;
};
export default Scripts;